import React from 'react';
import { useQuery, useMutation, gql } from '@apollo/client';
import UnserializedPurchaseOrders from './UnserializedPurchaseOrders';
import ApiError from '@/lib/shared-coms/ApiError';
import { Spinner } from 'equasion-lib';
import { BULK_PRODUCT_STATUS_UPDATE } from '@/lib/graphql/fragments';
import { useRootStore } from '@/lib/providers/RootProvider';

const OTC_PURCHASE_ORDERS = gql`
  query unserializedPurchaseOrders($clientId: ID!) {
    unserializedPurchaseOrders(clientId: $clientId) {
      id
      clientPurchaseOrderNumber
      clientStatus
      vendor {
        id
        companyName
      }
      orderItems {
        id
        quantity
        product {
          id
          title
          fdaProduct {
            id
            name
            elevenDigitNdc
            deaSchedule
          }
          upcProduct {
            id
            upc
          }
        }
      }
    }
  }
`;

const OTC_BULK_PRODUCT_CREATE = gql`
  mutation unserializedBulkProductCreate($missingCount: Int, $purchaseOrderItemId: ID!) {
    unserializedBulkProductCreate(
      missingCount: $missingCount
      purchaseOrderItemId: $purchaseOrderItemId
    )
  }
`;

const UnserializedPurchaseOrdersData = (props) => {
  const clientId = useRootStore((state) => state.selectedCompany.id);
  const [bulkProductStatusUpdate] = useMutation(BULK_PRODUCT_STATUS_UPDATE);
  const [unserializedBulkProductCreate] = useMutation(OTC_BULK_PRODUCT_CREATE);

  const { data, error, loading, refetch } = useQuery(OTC_PURCHASE_ORDERS, {
    fetchPolicy: 'network-only',
    variables: { clientId }
  });

  if (loading) return <Spinner />;
  if (error) return <ApiError error={error} />;

  const { unserializedPurchaseOrders } = data || {};

  return (
    <UnserializedPurchaseOrders
      purchaseOrders={unserializedPurchaseOrders}
      bulkProductStatusUpdate={bulkProductStatusUpdate}
      unserializedBulkProductCreate={unserializedBulkProductCreate}
      clientId={clientId}
      refetch={refetch}
      {...props}
    />
  );
};

export default UnserializedPurchaseOrdersData;
